"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ButtonBase = _interopRequireDefault(require("./ButtonBase"));
var _propTypes2 = _interopRequireWildcard(require("./propTypes"));
var _props = require("../utils/props");
var _ThemeProvider = require("../ThemeProvider");
var _ViewportProvider = require("../ViewportProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * `ButtonLink` is a component with the semantics and behaviour of a link, but with the visual appearance of a button.
 * ButtonLink is a block-level component and should not be used inline.
 */const ButtonLink = /*#__PURE__*/_react.default.forwardRef((_ref, ref) => {
  let {
    accessibilityRole = 'link',
    tokens,
    variant,
    dataSet,
    ...props
  } = _ref;
  const {
    hrefAttrs,
    rest
  } = _props.hrefAttrsProp.bundle(props);
  const viewport = (0, _ViewportProvider.useViewport)();
  const buttonVariant = {
    viewport,
    ...variant
  };
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('Button', tokens, buttonVariant);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ButtonBase.default, {
    ref: ref,
    accessibilityRole: accessibilityRole,
    tokens: getTokens,
    hrefAttrs: hrefAttrs,
    dataSet: dataSet,
    ...rest
  });
});
ButtonLink.displayName = 'ButtonLink';
ButtonLink.propTypes = {
  ..._props.a11yProps.types,
  ..._propTypes2.default,
  ..._props.linkProps.types,
  ..._props.contentfulProps.types,
  children: _propTypes2.textAndA11yText,
  dataSet: _propTypes.default.object,
  accessibilityRole: _propTypes.default.string
};
var _default = exports.default = ButtonLink;